// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".storeEdit[data-v-4bb308da]{padding:0 35px}.pictrue[data-v-4bb308da]{width:36px !important;height:36px !important}", ""]);
// Exports
module.exports = exports;
